import styles from "../general/SettingsGeneral.module.scss";
import useSettingsCars from "./useSettingsCars";
import Card from "../../../common/Card";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import Button from "../../../common/Button";
import {Checkbox} from "../../../common/Checkbox";
import {AccountsDropdown} from "../../../common/AccountsDropdown";
import {CategoriesDropdown} from "../../../common/CategoriesDropdown";
import {Content, ContentFixed} from "../../../common/Content";
import {SettingsMenuMobile} from "../Settings";
import {SettingsContent} from "../SettingsContent";
import {SettingsTopMenu} from "../SettingsTopMenu";

const SettingsCars = () => {
  const {
    t,
    submit,
    updateSettings,
    editedSettings,
    availableAccounts,
    availableCategories
  } = useSettingsCars();

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_cars"/>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent>
        <Card>
          <Form onSubmit={submit} className={styles.form}>
            <Form.Group as={Row} className="mb-2" controlId="settings-active">
              <Form.Label column sm={5} md={4} lg={4}>
                {t("settings_cars_editor_field_active")}
              </Form.Label>
              <Col sm={7} md={6} lg={4}>
                <Checkbox
                  id="settings-active"
                  checked={editedSettings.featureCarsActive}
                  onChange={updateSettings("featureCarsActive")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2 mt-2" controlId="settings-cars-default-account">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_cars_editor_field_default_account")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AccountsDropdown
                  value={editedSettings.defaultCarsAccount}
                  onChange={updateSettings("defaultCarsAccount")}
                  accounts={availableAccounts}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-4" controlId="settings-car-default-category">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_cars_editor_field_default_category")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <CategoriesDropdown
                  categories={availableCategories}
                  value={editedSettings.defaultCarsTransactionCategory}
                  onChange={updateSettings("defaultCarsTransactionCategory")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={5} md={4} lg={4}/>
              <Col sm={7} md={6} lg={4}>
                <Button type="submit">{t("btn_save_settings_cars")}</Button>
              </Col>
            </Form.Group>
          </Form>
        </Card>
      </SettingsContent>
    </Content>
  );
};

export default SettingsCars;
